
import Vue from "vue";
import { DashboardItem } from "@/utils/dashboard/dashboard-item";
import AppTinyInfo from "./TinyInfo.vue";
import { DashboardChartData } from "@/utils/dashboard/dashboard-chart-data";
import {ChartService} from "@/services";

export default Vue.extend({
	data(){
		return {
			totalIncome: 0.0
		};
	},
	props: {
		item: {
			type: Object as ()=>DashboardItem,
			required: true
		}
	},
	computed: {
		chartData():DashboardChartData{
			return this.item.Data as DashboardChartData;
		}
	},
	methods: {
		async fetch(){
			this.totalIncome = await ChartService.getTotalIncome(this.chartData.filters, this.chartData.getBookYearOverrideValue());
		}
	},
	created(){
		this.fetch();
	},
	components: {
		AppTinyInfo
	},
	i18nEx: {
		componentPrefix: "views.HomeRoute"
	}
});
